/**
 * Job Field Options Configuration
 * 
 * Centralized dropdown options for project/job fields.
 * These can be swapped to dynamic API-driven options later
 * without refactoring the form components.
 * 
 * Usage:
 *   import { PAYMENT_PLANS, WARRANTIES, PRODUCTS } from '@/config/jobFieldOptions';
 */

// Payment Plan Options
export const PAYMENT_PLANS = [
  { value: 'cash', label: 'Cash' },
  { value: 'finance', label: 'Finance' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'ach', label: 'ACH' },
  { value: 'check', label: 'Check' },
  { value: 'split_payment', label: 'Split Payment' },
];

// Warranty Options
export const WARRANTIES = [
  { value: '10_year', label: '10 Year' },
  { value: '15_year', label: '15 Year' },
  { value: '25_year', label: '25 Year' },
  { value: 'lifetime', label: 'Lifetime' },
];

// Product Used Options
export const PRODUCTS = [
  { value: 'rhino_shield', label: 'Rhino Shield' },
];

// Project Type Options
export const PROJECT_TYPES = [
  { value: 'residential', label: 'Residential' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'hoa', label: 'HOA' },
  { value: 'multi_family', label: 'Multi-Family' },
];

// HOA Approval Status
export const HOA_APPROVAL_STATUS = [
  { value: 'not_required', label: 'Not Required' },
  { value: 'required', label: 'Approval Required' },
  { value: 'approved', label: 'Approved' },
  { value: 'pending', label: 'Pending Approval' },
  { value: 'denied', label: 'Denied' },
];

// US States for address fields
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

/**
 * Helper to get label from value
 * @param {Array} options - Options array
 * @param {string} value - Value to find
 * @returns {string} Label or original value if not found
 */
export const getOptionLabel = (options, value) => {
  const option = options.find(o => o.value === value);
  return option ? option.label : value || '—';
};

/**
 * Future: Replace with API call
 * export const fetchOptions = async (fieldType) => {
 *   const response = await axios.get(`/api/job-field-options?type=${fieldType}`);
 *   return response.data;
 * };
 */
